<div class="card-vehicle" (click)="goToDetails()" role="button" tabindex="0">
  <div class="card-media">
    @if (imageUrl(); as url) {
      <img [src]="url" [alt]="title()" class="card-img" loading="lazy" />
    } @else {
      <div class="card-img-placeholder">
        <i class="fa-solid fa-car" aria-hidden="true"></i>
      </div>
    }

    <button
      type="button"
      class="card-fav-btn"
      [class.card-fav-btn--active]="isFavorited()"
      (click)="toggleFavorite($event)"
      [attr.aria-label]="isFavorited() ? 'Remover dos favoritos' : 'Salvar como favorito'"
    >
      @if (isFavorited()) {
        <i class="fa-solid fa-heart" aria-hidden="true"></i>
      } @else {
        <i class="fa-regular fa-heart" aria-hidden="true"></i>
      }
    </button>
  </div>

  <div class="card-content">
    <div class="card-header-info">
      <span class="card-title" [title]="title()">{{ title() }}</span>
      @if (subtitle(); as sub) {
        <span class="card-subtitle">{{ sub }}</span>
      }
    </div>

    <div class="card-price-row">
      <span class="card-price">{{ priceFormatted() }}</span>
      @if (fipeDiscountFormatted(); as fipe) {
        <span
          class="card-fipe-badge"
          [class.card-fipe-badge--discount]="isFipeDiscount()"
        >
          @if (isFipeDiscount()) {
            <i class="fa-solid fa-arrow-trend-down" aria-hidden="true"></i>
          }
          {{ fipe }}
        </span>
      }
    </div>

    <div class="card-footer-row">
      @if (hasApprovedReport()) {
        <span class="card-badge-report">Laudo aprovado</span>
      }
      <span class="card-location">
        <i class="fa-solid fa-location-dot" aria-hidden="true"></i>
        <span>{{ location() }}</span>
      </span>
    </div>
  </div>
</div>
